import React from 'react';
import PageTitle from 'components/common/PageTitle';
import { useTranslation } from 'react-i18next';

const Briefing = () => {
  const { t } = useTranslation();

  const title = 'Briefing';

  return (
    <div>
      <PageTitle title={title} />
      <div className="page-content pt-6 mb-6">
        <div style={{ color: 'gray', textAlign: 'center', fontSize: '16pt' }}>
          {t('This section is under construction')}
          {/* This section is under construction, come back soon to discover more... */}
        </div>
        {/* {items.length < 3 && (
          <Row>
            {items.map((item, index) => (
              <Col key={index} md="6" className="mb-4">
                <NavItemComponent {...item} className="mb-4 h-100" />
              </Col>
            ))}
          </Row>
        )}
        {items.length === 3 && (
          <Row>
            {items.map((item, index) => (
              <Col key={index} md="4" className="mb-4">
                <NavItemComponent {...item} className="mb-4 h-100" />
              </Col>
            ))}
          </Row>
        )}
        {items.length > 3 && (
          <Row>
            {items.map((item, index) => (
              <Col key={index} md="3" className="mb-4">
                <NavItemComponent {...item} className="mb-4 h-100" />
              </Col>
            ))}
          </Row>
        )} */}
      </div>
    </div>
  );
};

export default Briefing;
